"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAnnotations = exports.readData = void 0;
const java_class_tools_1 = require("java-class-tools");
const utils_1 = require("./utils");
const bytes_1 = require("./bytes");
const CONSTANT_Module = 19;
const CONSTANT_Package = 20;
function readData(constant_pool, index) {
    if (utils_1.isEmpty(constant_pool) || utils_1.isEmpty(index))
        return {};
    const pool = constant_pool;
    const info = pool[index];
    if (utils_1.isEmpty(info) || utils_1.isEmpty(info.tag))
        return {};
    switch (info.tag) {
        case java_class_tools_1.ConstantType.UTF8:
        case java_class_tools_1.ConstantType.INTEGER:
        case java_class_tools_1.ConstantType.FLOAT:
            {
                const value = bytes_1.bytes2String(info.bytes);
                return {
                    name: utils_1.parseName(value),
                };
            }
        case java_class_tools_1.ConstantType.LONG:
        case java_class_tools_1.ConstantType.DOUBLE:
            {
                return {
                    name: ((BigInt(info.high_bytes) << 32n) + BigInt(info.low_bytes)).toString(),
                };
            }
        case java_class_tools_1.ConstantType.CLASS:
        case java_class_tools_1.ConstantType.STRING:
            {
                const value = pool[info.name_index | info.string_index];
                const valueChild = bytes_1.bytes2String(value.bytes);
                return {
                    name: utils_1.parseName(valueChild),
                };
            }
        case java_class_tools_1.ConstantType.FIELDREF:
        case java_class_tools_1.ConstantType.METHODREF:
        case java_class_tools_1.ConstantType.INTERFACE_METHODREF:
            {
                const clazzInfo = pool[info.class_index];
                const classInfoNameInfo = pool[clazzInfo.name_index];
                const clazz = bytes_1.bytes2String(classInfoNameInfo.bytes);
                const nameAndTypeInfo = pool[info.name_and_type_index];
                const nameAndTypeNameInfo = pool[nameAndTypeInfo.name_index];
                const name = bytes_1.bytes2String(nameAndTypeNameInfo.bytes);
                const descriptorInfo = pool[nameAndTypeInfo.descriptor_index];
                const descriptor = bytes_1.bytes2String(descriptorInfo.bytes);
                return {
                    class: utils_1.parseName(clazz),
                    name: utils_1.parseName(name),
                    descriptor: utils_1.parseName(descriptor),
                };
            }
        case java_class_tools_1.ConstantType.NAME_AND_TYPE:
            {
                const { descriptor_index, name_index, } = info;
                const nameInfo = pool[name_index];
                const name = bytes_1.bytes2String(nameInfo.bytes);
                const descriptorInfo = pool[descriptor_index];
                const descriptor = bytes_1.bytes2String(descriptorInfo.bytes);
                return {
                    name: utils_1.parseName(name),
                    descriptor: utils_1.parseName(descriptor),
                };
            }
        case java_class_tools_1.ConstantType.METHOD_HANDLE:
            {
                const { reference_kind: referenceKind, reference_index: referenceIndex } = info;
                return {
                    referenceKind,
                    referenceIndex,
                };
            }
        case java_class_tools_1.ConstantType.METHOD_TYPE:
            {
                const descriptorInfo = pool[info.descriptor_index];
                const descriptor = bytes_1.bytes2String(descriptorInfo.bytes);
                return {
                    descriptor: utils_1.parseName(descriptor),
                };
            }
        case java_class_tools_1.ConstantType.DYNAMIC:
            {
                return {};
            }
        case java_class_tools_1.ConstantType.INVOKE_DYNAMIC:
            {
                const nameAndTypeInfo = pool[info.name_and_type_index];
                const nameAndTypeName = pool[nameAndTypeInfo.name_index];
                const name = bytes_1.bytes2String(nameAndTypeName.bytes);
                return {
                    name: utils_1.parseName(name),
                };
            }
        case CONSTANT_Module:
            {
                return {};
            }
        case CONSTANT_Package:
            {
                return {};
            }
        default:
            {
                const value = bytes_1.bytes2String(info.bytes);
                return {
                    name: utils_1.parseName(value),
                };
            }
    }
}
exports.readData = readData;
function getAnnotations(constant_pool, annotations) {
    const annotationsResult = {};
    annotations.forEach(({ type_index, element_value_pairs }) => {
        const annotationAttr = {};
        const attributeName = readData(constant_pool, type_index);
        if (element_value_pairs !== undefined) {
            element_value_pairs.forEach(({ element_name_index, element_value }) => {
                const name = readData(constant_pool, element_name_index);
                const attributeValue = readData(constant_pool, element_value.value.const_value_index);
                if (attributeValue === undefined)
                    return;
                annotationAttr[name.name] = attributeValue.name;
            });
        }
        annotationsResult[attributeName.name] = annotationAttr;
    });
    return annotationsResult;
}
exports.getAnnotations = getAnnotations;
